import React, {useEffect, useState} from 'react'
import {Card, Image} from 'semantic-ui-react'
import {Link} from 'gatsby'
import * as styles from './styles/productList.module.css'


const displayDateTime = (datestr) => {
	let monthlist=["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	let dateobj = new Date(datestr);

	return monthlist[dateobj.getMonth()]+" "+dateobj.getDate();

/*
	// 2021-08-27 - Remove Time info
	let timestr = "";
	let hours = dateobj.getHours();
	let mins = dateobj.getMinutes();
	let ampm = "";

	if (hours === 0) {
		if (mins > 0) {
			ampm = "am";
			timestr = "12";
		}
	} else if (hours > 0 && hours < 12) {
		ampm = "am";
		timestr = " "+hours;
	} else if (hours === 12) {
		ampm = "nn";
		timestr = " "+hours;
	} else if (hours < 23) {
		ampm = "pm";
		timestr = " "+(hours-12);
	} else {
		// Check against 23:59
		if (mins !== 59) {
			ampm = "pm";
			timestr = " "+(hours-12);
		}
	}

	if (mins < 59 && mins > 0) {
		// 59 is end of day
		if (mins < 10) {
			timestr = timestr+ ":0"+mins;
		} else {
			timestr = timestr+ ":"+mins;
		}
	}
	return monthlist[dateobj.getMonth()]+" "+dateobj.getDate()+timestr+ampm;
*/
}

const mapProductsToItems = (products, space, cameFrom, page, type, offset, listName) => {
	return products.map(({name, id, mainImageHref, meta, url, sku, available, squareImageHref, startdate, enddate }, index) => {
		let price
		if(meta) {
			price = meta.display_price.with_tax.formatted || null
		}

		let productName ="";
		let strings = name.split(" ");
		let length = 0;
		let line = 1;
		for(let i=0;i<strings.length;i++) {
			if(line===2 && (length + strings[i].length +.5 > space-3) ) {

				const lastIndex = productName.lastIndexOf(" ");
				productName = productName.substr(0, lastIndex);
				productName = productName.concat("...");
				break;
			}else if( (length + strings[i].length +.5 > space) ) {
				line++;
				length = strings[i].length+.5
				productName = productName.concat(`${strings[i]} `);

			}else {
				length+=strings[i].length+.5;
				productName = productName.concat(`${strings[i]} `);
			}
		}

		return (
			<Card
				as={Link}
				to={`/${url}/`}
				state={{
					cameFrom,
					page,
					index:index+1
				}}
				key={type==="product" ? id:url}
				onClick={()=>{
					if(type==="product") {
						let positionOffset = 0
						if(page && offset) {
							positionOffset= (page-1)*offset
						}
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							'event':'productClick',
							'ecommerce': {
								'click': {
									'actionField': {'list':listName},
									'products': [{
										'name':name,
										'id':sku,
										'price':parseFloat(meta.display_price.with_tax.amount),
										'position':positionOffset+index+1,
										'item_id': sku,
										'item_name': name,
										'currency': "PHP",
										'index': positionOffset+index+1,
										'item_list_id': listName,
										'item_list_name': listName,
										'quantity': 1
									}]
								}
							}
						});
					}
				}}
			>
				<Image fluid alt={name} src={type==="category"? squareImageHref: mainImageHref} />
				<Card.Content className={styles.card}>
					<Card.Header className={styles.productname}>{productName}</Card.Header>
					<Card.Meta className={styles.meta}>{price}</Card.Meta>
					{available===false && (
						<Card.Description>
							<div className={`${styles.meta} ${styles.warningMessage}`}>Product no longer available.</div>
						</Card.Description>
					)}
				</Card.Content>
				{ (startdate !== undefined && enddate !== undefined) &&
					<Card.Content extra>
						<div className={`${styles.meta} ${styles.warningMessage}`}>{displayDateTime(startdate)}{" to "+displayDateTime(enddate)+" only"}</div>
					</Card.Content>

				}
			</Card>
		)
	})
}
export default ({products, shown, grid, cameFrom, page, offset, listName, type="product"}) => {
	const [windowWidth, setWindowWidth] = useState(0)


	useEffect(()=> {
		setWindowWidth(window.innerWidth)
	}, [])

	useEffect(()=>{
		if(type==="product") {
			let positionOffset = 0
			if(page && offset) {
				positionOffset= (page-1)*offset
			}
			const dataLayerList = products.map(({name, sku, meta}, index)=>{
				return {
					'name': name,
					'id': sku,
					'price': parseFloat(meta.display_price.with_tax.amount),
					'list': listName,
					'position':positionOffset+index+1,
					'item_id': sku,
					'item_name': name,
					'currency': "PHP",
					'index': positionOffset+index+1,
					'item_list_id': listName,
					'item_list_name': listName,
					'quantity': 1
				}
			})
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'productList',
				'ecommerce': {
					'impressions': dataLayerList
				}
			});
		}
		/*Sept. 16 2020
		 *[product[0].url] works because when getting new products, the productList gets unmounted and a Loader is replaced with it
		 *though this assumes that the product url will always be unique and that the product list will get unmounted while getting new products
		 */
	}, [products[0].url])


	let containerWidth = 0;
	let fontSize = 0;

	/*windowWidth if values are from https://semantic-ui.com/elements/container.html*/
	if(windowWidth > 1200 ) {
		fontSize=11.5
		containerWidth = 1127
	}else if( windowWidth <= 1200 && windowWidth >= 992 ) {
		fontSize=11
		containerWidth = 933
	}else if( windowWidth <= 991 && windowWidth >= 768 ) {
		fontSize=10.5
		containerWidth = 723
	}else if( windowWidth < 768 ) {
		fontSize=9.5
		containerWidth = windowWidth-28
	}
	let space = (containerWidth* grid / 16 /shown ) -15 /*-15 for margin*/
	space = space / fontSize

	return (
		<Card.Group
			itemsPerRow={shown}
		>
			{mapProductsToItems(products, space, cameFrom, page, type, offset, listName)}
		</Card.Group>
	)
}
